import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AppContext } from "../../context";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

let source;

const TermsPage = () => {
  const [text, setText] = useState("");
  const { state } = useContext(AppContext);
  const { config, culture, language, posId } = state;

  useEffect(() => {
    let CancelToken = axios.CancelToken;
    source = CancelToken.source();
    axios
      .get(
        `${config.baseUrl}/ee-static/checkout/pos-${posId}/Texts/terms.${culture}.md`
      )
      .then((res) => setText(res.data))
      .catch((e) => console.error(e));

    return () => source.cancel("Component Is Unmounting");
  }, [culture, posId]);

  useEffect(() => {
    if (config && language) {
      document.title = `${language.TermsTitle} - ${config.shopName}`;
    }
  }, [config, language]);

  return (
    <ReactMarkdown className="terms__text" rehypePlugins={[rehypeRaw]}>
      {text}
    </ReactMarkdown>
  );
};

export default TermsPage;
